var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{attrs:{"id":"APP"}},[_c('router-view'),_c('div',{staticClass:"kefu"},[_c('van-icon',{attrs:{"name":"chat-o"}})],1),(_vm.showKf)?_c('div',{staticClass:"kf",on:{"click":_vm.toKefu}},[_c('img',{attrs:{"src":require("./assets/images/online.png")}})]):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }